<mat-radio-group
  [ngModel]="value"
  [class]="
    box()
      ? [
          justify,
          'box',
          'm-border',
          'm-border-radius:sm',
          'm-bg-color:neutral-soft',
          'm-padding-v:2',
          'm-padding-h:4',
        ]
      : justify
  "
  [class.column]="display === 'column'"
  [required]="required"
  [labelPosition]="labelPosition"
  [disabled]="disabled || readonly"
  (change)="onChange($event.value)"
>
  @for (option of options; track option.value ?? $index) {
    <mat-radio-button
      [class.disabled]="option.readonly || disabled || readonly"
      [class.position-before]="labelPosition === 'before'"
      [value]="option.value"
      [disabled]="option.readonly"
      [disableRipple]="true"
    >
      {{ option.label | translate }}
    </mat-radio-button>
  }
</mat-radio-group>
